module.exports = __webpack_public_path__ + "static/media/choithramsLayerFour.7aa9d89e.png";